import { render, staticRenderFns } from "./divideTableHeader.vue?vue&type=template&id=28cf831b&scoped=true&"
import script from "./divideTableHeader.vue?vue&type=script&lang=js&"
export * from "./divideTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./divideTableHeader.vue?vue&type=style&index=0&id=28cf831b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf831b",
  null
  
)

export default component.exports